import { FC } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import Spin, { SpinProps } from 'antd/es/spin';

import theme from '@theme';

import { SpinnerWrapper } from './styled';

export interface ISpinner {
  className?: string;
  circularProgressProps?: SpinProps;
  color?: string;
}

const Spinner: FC<ISpinner> = ({ circularProgressProps, className, color }) => {
  return (
    <SpinnerWrapper className={className} data-testid='spinner'>
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 24,
              color: color || theme.palette['primaryBrand'],
            }}
            spin
          />
        }
        {...circularProgressProps}
      />
    </SpinnerWrapper>
  );
};

export default Spinner;
